import axios from "axios";

export const customerApi = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND}api/stk-customer`,
  headers: {
    "Content-Type": "application/json",
  },
});
